import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

export const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright={false}
      links={[
        {
          key: 'i-pos',
          title: 'Powered by I-POS',
          href: 'https://www.i-pos.com.au/',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
